import  {SAVE_CONNECTION_EMPTY, SAVE_CONNECTION_ERROR, SAVE_CONNECTION_PENDING, SAVE_CONNECTION_SUCCESS} from "../constants/actionTypes";
import * as api from "../api/index.js";

export const saveConnection = (formData) => async (dispatch) => {
  dispatch({ type: SAVE_CONNECTION_PENDING }); // 1. pending

  try {
    const response = await api.saveConnection(formData);

    if (!response?.data) {
      dispatch({ type: SAVE_CONNECTION_EMPTY }); // 2. No data, but no error
      return;
    }

    dispatch({
      type: SAVE_CONNECTION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error("SAVE_CONNECTION error", error);
    dispatch({
      type: SAVE_CONNECTION_ERROR, // 4. error
      payload: error.response?.data?.message || "Failed to save connection.",
    });
    throw new Error(
      error.response?.data?.detail || "Failed to save connection."
    );
  }
};

